import type { AdminQueryPort } from "../../contracts/admin-query-port";
import type {
  AdminOverviewQuery,
  AdminOverviewSummary,
  AdminQueryEnvelope,
} from "../../contracts/admin-read-models";

export async function loadOverviewSummary(
  port: AdminQueryPort,
  query: AdminOverviewQuery,
): Promise<AdminQueryEnvelope<AdminOverviewSummary>> {
  return port.getOverviewSummary(query);
}
